module.exports = __webpack_public_path__ + "img/coupon.f211be85.svg";